var exports = {
  "Y": "renderedInput__wxmaP1",
};

module.exports = exports;
